export const ToastFail = (fail) => {
    if (fail) {
        return fail === 'EDIT_OFFICE' ? 'Something went wrong' :

                    false;
    }
};
